function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Warstwa 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Warstwa 1"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Done icon",
  d: "M5.72 10.33l-4.29-4.1L0 7.6l5.72 5.45L18 1.36 16.53 0z"
})));

function SvgDoneicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17.96 13.05"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNy45NiAxMy4wNSI+PGcgaWQ9IldhcnN0d2FfMiIgZGF0YS1uYW1lPSJXYXJzdHdhIDIiPjxnIGlkPSJXYXJzdHdhXzEtMiIgZGF0YS1uYW1lPSJXYXJzdHdhIDEiPjxwYXRoIGlkPSJEb25lX2ljb24iIGRhdGEtbmFtZT0iRG9uZSBpY29uIiBkPSJNNS43MiwxMC4zMywxLjQzLDYuMjMsMCw3LjZsNS43Miw1LjQ1TDE4LDEuMzYsMTYuNTMsMFoiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgDoneicon as ReactComponent };